import React, { useState } from 'react';
import FileUploader from '../components/FileUploader';
import ProcessingIndicator from '../components/ProcessingIndicator';
import { loadImage } from '../utils/imageUtils';
import jsPDF from 'jspdf';
import { saveAs } from 'file-saver';
import './ToolPage.css';

const ImageToPDF = () => {
    const [files, setFiles] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [processedFile, setProcessedFile] = useState(null);

    const handleFilesSelected = (selectedFiles) => {
        setFiles(selectedFiles);
        setProcessedFile(null);
    };

    const handleConvert = async () => {
        if (files.length === 0) return;

        setProcessing(true);

        try {
            const pdf = new jsPDF();
            let isFirstPage = true;

            for (const file of files) {
                const img = await loadImage(file);

                // Calculate PDF dimensions
                const imgWidth = img.width;
                const imgHeight = img.height;
                const pdfWidth = 210; // A4 width in mm
                const pdfHeight = (imgHeight * pdfWidth) / imgWidth;

                if (!isFirstPage) {
                    pdf.addPage();
                }
                isFirstPage = false;

                const imgData = await fileToDataURL(file);
                pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
            }

            const pdfBlob = pdf.output('blob');
            setProcessedFile(new File([pdfBlob], 'images.pdf', { type: 'application/pdf' }));
        } catch (error) {
            alert('Conversion failed: ' + error.message);
        } finally {
            setProcessing(false);
        }
    };

    const fileToDataURL = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsDataURL(file);
        });
    };

    const handleDownload = () => {
        if (processedFile) {
            saveAs(processedFile, processedFile.name);
        }
    };

    return (
        <div className="tool-page">
            <div className="tool-header">
                <h1>📄 Image to PDF</h1>
                <p>Combine multiple images into a single PDF file</p>
            </div>

            <div className="tool-content">
                <FileUploader
                    accept="image/*"
                    onFilesSelected={handleFilesSelected}
                    title="Upload Images"
                    description="Supports multiple images, will be merged in order to PDF"
                />

                {files.length > 0 && !processing && !processedFile && (
                    <div className="tool-controls">
                        <button className="btn btn-primary" onClick={handleConvert}>
                            Convert to PDF
                        </button>
                    </div>
                )}

                {processing && <ProcessingIndicator message="Generating PDF..." />}

                {processedFile && (
                    <div className="results">
                        <h3>Conversion Complete!</h3>
                        <p>Merged {files.length} image(s) into PDF</p>
                        <button className="btn btn-primary" onClick={handleDownload}>
                            Download PDF
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageToPDF;
